import React from 'react';

import { Typography, Button } from '@mui/material';

import { useSelector, useDispatch } from 'react-redux';
import {
  selectIsChartVisible,
  selectOverviewTab,
} from '../../store/ui/ui.selector';
import { changeChartTab, toggleChartVisible } from '../../store/ui/ui.slice';
import { selectCurrentLocation } from '../../store/map/map.selector';
import {
  selectIsClimate,
  selectTheme,
  selectUseAlternateData,
} from '../../store/options/options.selector';
import { changeUseAlternateData } from '../../store/options/options.slice';

import './overview-btn-group.styles.scss';

export default function OverviewBtnGroup() {
  const dispatch = useDispatch();
  const tab = useSelector(selectOverviewTab);
  const loc = useSelector(selectCurrentLocation);
  const isClimate = useSelector(selectIsClimate);
  const isChartVisible = useSelector(selectIsChartVisible);
  const theme = useSelector(selectTheme);
  const useAlternate = useSelector(selectUseAlternateData);

  const handleToggleChart = () => {
    dispatch(toggleChartVisible());
  };

  const openChartTab = (tabName) => {
    dispatch(changeChartTab(tabName));
    handleToggleChart();
  };

  const handleChangeAlternateData = () => {
    dispatch(changeUseAlternateData(useAlternate === 'hurricane' ? false : 'hurricane'));
  };

  const renderSingleButton = (btnText, onClick) => {
    return (
      <Button className='overview-btn' variant='contained' onClick={onClick}>
        {btnText}
      </Button>
    );
  };

  const renderDoubleButton = (btn1Text, btn1OnClick, btn2Text, btn2OnClick) => {
    return (
      <div className='two-btns'>
        <Button
          className='overview-btn'
          variant='contained'
          onClick={btn1OnClick}
          sx={{ lineHeight: 1.1 }}
        >
          {btn1Text}
        </Button>
        <Button
          className='overview-btn'
          variant='contained'
          onClick={btn2OnClick}
          sx={{ lineHeight: 1.1 }}
        >
          {btn2Text}
        </Button>
      </div>
    );
  };

  return (
    <>
      {tab === 'local' && !loc.state && (
        <Typography
          variant='caption'
          style={{ margin: '0 auto', lineHeight: 1.1 }}
        >
          Click on a county for more location specific information
        </Typography>
      )}

      {!isClimate &&
        (theme === 5 && isChartVisible
          ? renderDoubleButton(
              `Use ${useAlternate === 'hurricane' ? 'Storm Database' : 'Hurricane API'} Data`,
              handleChangeAlternateData,
              'Hide Annual Data',
              handleToggleChart
            )
          : renderSingleButton(
              `${isChartVisible ? 'Hide' : 'Show'} Annual Data`,
              handleToggleChart
            ))
      }

      {isClimate &&
        (isChartVisible
          ? renderSingleButton('Hide Chart', handleToggleChart)
          : renderDoubleButton(
              'Show Historical Data',
              () => openChartTab('historical'),
              'Show Projected Data',
              () => openChartTab('high')
            ))}
    </>
  );
}
